import styled, { css } from 'styled-components';

export const heavyShadow =
  '0 0 3px 1px rgba(0,0,0,0.05), 0 1px 1px 0 rgba(9,30,66,0.25)';

// Content inside a card (grids, chart fills, headings) paints bg-primary to
// match its surface. Re-point it at the raised colour so it matches the card
// rather than the page behind it.
export const raisedSurfaceStyle = css`
  --color-bg-primary: var(--color-bg-raised);
`;

const noPaddingStyle = css`
  padding: unset;
`;

const darkMode = css`
  background-color: var(--color-brand-dark);
  box-shadow: unset;
  border: 2px solid var(--color-brand-dark-alt);
  border-radius: 5px;

  &:hover {
    background-color: var(--color-brand-dark);
    opacity: 0.7;
  }
`;

const getHoverBackgroundColor = (
  darkenOnHover?: boolean,
  noBackground?: boolean,
) => {
  if (noBackground) {
    return 'unset';
  }

  if (darkenOnHover) {
    return 'var(--color-bg-frosted)';
  }

  return 'var(--color-bg-raised)';
};

const Card = styled.div<{
  darkenOnHover?: boolean;
  hideBorders?: boolean;
  heavyShadow?: boolean;
  compactShadow?: boolean;
  darkMode?: boolean;
  noBackground?: boolean;
  noPadding?: boolean;
  clickable?: boolean;
}>`
  position: relative;
  border-radius: 8px;
  border: ${(props) =>
    props.hideBorders ? 'unset' : '1px solid var(--color-border-tertiary)'};
  background-color: ${(props) =>
    props.noBackground ? 'unset' : 'var(--color-bg-raised)'};
  ${(props) => !props.noBackground && raisedSurfaceStyle};
  ${(props) => props.noPadding && noPaddingStyle};
  pointer-events: auto;

  &:hover {
    background-color: ${(props) =>
      getHoverBackgroundColor(props.darkenOnHover, props.noBackground)};
  }

  ${(props) => props.darkMode && darkMode};
  cursor: ${(props) => (props.clickable ? 'pointer' : 'unset')};
  overflow: hidden;
`;

export default Card;
